import { render, staticRenderFns } from "./StudentRecord.vue?vue&type=template&id=10d76b80&scoped=true"
import script from "./StudentRecord.vue?vue&type=script&lang=js"
export * from "./StudentRecord.vue?vue&type=script&lang=js"
import style0 from "./StudentRecord.vue?vue&type=style&index=0&id=10d76b80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d76b80",
  null
  
)

export default component.exports